import * as React from 'react'
import { Box, Button } from '@mui/material'
import { createNewPartner, getPartnerFolders } from './Utility'
import { PlainLink } from 'app/components/RouteLink'

export function IngestionIndex() {
  const [partners, setPartners] = React.useState<string[]>([])
  const [showAdd, setShowAdd] = React.useState(false)

  React.useEffect(() => {
    getPartners()
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [])

  function getPartners() {
    getPartnerFolders((partnerFiles) => {
      setPartners(partnerFiles.map((p) => p.textContent!.split('/')[1]))
    })
  }

  function partnerAdded() {
    setShowAdd(false)
    getPartners()
  }

  return (
    <Box>
      <p>Ingestion</p>
      <Box>
        <h3>Partners</h3>
        <Box padding={'5px'}>
          {partners.map((p, i) => {
            return (
              <Box key={i}>
                <Button component={PlainLink} to={`/ingestion/partner/${p}`}>
                  {p}
                </Button>
              </Box>
            )
          })}
        </Box>
      </Box>
      {!showAdd && (
        <Button onClick={() => setShowAdd(!showAdd)}>Add Partner</Button>
      )}
      {showAdd && <AddPartner onAdded={partnerAdded} />}
    </Box>
  )
}

function AddPartner({ onAdded }: { onAdded: () => void }) {
  const [newName, setNewName] = React.useState('')
  function addPartner() {
    if (!newName.length) {
      onAdded()
      return
    }
    createNewPartner(newName, onAdded)
  }

  return (
    <Box>
      <input value={newName} onChange={(e) => setNewName(e.target.value)} />
      <Button onClick={addPartner}>Add Partner</Button>
    </Box>
  )
}
